import { z } from "zod";

/**
 * Zod schema for Partner form validation
 * Messages updated to use translation keys
 */
export const partnerSchema = z.object({
    firstName: z.string().min(1, "errors.firstNameRequired"),
    lastName: z.string().min(1, "errors.lastNameRequired"),
    // Note: zod built-in email/url messages can be customized
    companyEmail: z.string().email("errors.invalidEmail").min(1, "errors.emailRequired"),
    companyUrl: z.string().url("errors.invalidUrl").min(1, "errors.urlRequired"),
    details: z.string().optional(),
});
